export default __webpack_public_path__ + "static/media/how_to_2.14631664.png";